import 'zone.js'; // required unless using zoneless change detection
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { removeNestedCredentialsFromAddress } from './app/analytics/url-privacy';

// An app can send someone here with its sign-in handoff still inside `path`.
// Take it out of the address before PostHog, replay or the page read it.
removeNestedCredentialsFromAddress();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
